import BasicLayout from './basic';

export default BasicLayout;
